import { render, staticRenderFns } from "./InnerBeforeOuterAfter.vue?vue&type=template&id=540b3958&scoped=true"
import script from "./InnerBeforeOuterAfter.vue?vue&type=script&lang=js"
export * from "./InnerBeforeOuterAfter.vue?vue&type=script&lang=js"
import style0 from "./InnerBeforeOuterAfter.vue?vue&type=style&index=0&id=540b3958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b3958",
  null
  
)

export default component.exports